import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AssetByDate } from "../asset-assignment/dto/asset-by-date.dto";
import { AssetMaintainanceService } from "./asset-maintainance.service";
import { AssetById } from "./dto/asset-by-id.dto";
import { AssetMaintainanceDto } from "./dto/asset-maintainance.dto";
import { AssetByCode } from "./dto/asset-by-code.dto";

@Controller('maintainance')
@ApiTags('maintainance')
export class AssetMaintainanceController {
    constructor(
        private maitainanceService: AssetMaintainanceService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) {}

    
    @Post('/createAssetMaintainance')
    async createAssetMaintainance(@Body() createDto:AssetMaintainanceDto): Promise<CommonResponse> {
        try {
            return await this.maitainanceService.createAssetMaintainance(createDto);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/updateAssetMaintainance')
    async updateAssetMaintainance(@Body() updateDto:AssetMaintainanceDto): Promise<CommonResponse> {
        try {
            return await this.maitainanceService.updateAssetMaintainance(updateDto);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getAllAssetMaintainance')
    async getAllMaintainance() : Promise<CommonResponse>{
        try {
            return await this.maitainanceService.getAllMaintainance();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getAllMaintainanceTrans')
    async getAllMaintainanceTrans() : Promise<CommonResponse>{
        try {
            return await this.maitainanceService.getAllMaintainanceTrans();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getByAssetId')
    async getByAssetId(@Body() req:AssetByCode): Promise<CommonResponse> {
        try {
            return await this.maitainanceService.getByAssetId(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getTransById')
    async getTransById(@Body() req:AssetByCode): Promise<CommonResponse> {
        try {
            return await this.maitainanceService.getTransById(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getByDate')
    async getByDate(@Body() req:AssetByDate): Promise<CommonResponse> {
        try {
            return await this.maitainanceService.getByDate(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    @Post('/getAssetCodesDropDownformaintance')
    async getAssetCodesDropDownformaintance(@Body() req?:AssetByCode): Promise<CommonResponse> {
        try {
            return await this.maitainanceService.getAssetCodesDropDownformaintance(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getAssetCodesDropDownformaintanancetrans')
    async getAssetCodesDropDownformaintanancetrans(@Body() req?:AssetByCode): Promise<CommonResponse> {
        try {
            return await this.maitainanceService.getAssetCodesDropDownformaintanancetrans(req);
        } catch(err) {
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
    
    
}